require('./bootstrap');
require('./bootstrap.notify.min');
require('./validation');
require('./notify.min');


require('./cabinet');
require('./sidebar');
require('./oauth');
require('./ulogin');
